module.exports = __webpack_public_path__ + "static/media/shopping_transitional_marker.400360fe.svg";